import React, { useState } from "react";
import close from "../Assets/Images/close.png";
import sale from "../Assets/Images/sell.png";
import { useNavigate } from "react-router-dom";
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import CustomInput from "./Inputs/CustomInput";

const CustomFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  "& .MuiTypography-root": {
    fontSize: "14px",
  },
  "& .MuiRadio-root": {
    fontSize: "14px",
    "& svg": {
      width: "14px",
      height: "14px",
    },
  },
}));

const RealEstateAmount = ({ handleClose }) => {
  const navigate = useNavigate();

  const [salesType, setSalesType] = useState("One-off sale");
  const [amount, setAmount] = useState(0.0);

  return (
    <div className="flex flex-col justify-center items-center border-[1px] border-[#F0F0F5] w-[90%] sm:w-[553px] mt-[30px] mx-auto mb-[30px] h-[431px] rounded-[14px] shadow-xl relative bg-white">
      <div className="absolute top-3 right-3 cursor-pointer">
        <img
          src={close}
          alt="Close"
          className=" cursor-pointer w-6 h-6"
          onClick={handleClose}
        />
      </div>
      <div className="flex flex-col justify-center items-center w-full h-full">
        <h2 className="text-[16px] text-[#131E3D] font-[400] mb-4">
          Sell Units of Akeem Al’Ameed
        </h2>
        <CustomInput
          fullWidth
          noBorder
          bg={true}
          height={81}
          autoFocus={true}
          placeholder={`0`}
          customTextStyle={{}}
          autoComplete={"off"}
          textInputCustomStyles={{
            textAlign: "center",
            fontSize: "64px",
            color: "#131e3d",
          }}
          variant={"standard"}
          selfValue={amount}
          customType="amount"
          onChange={(e) => {
            setAmount(e.target.value);
          }}
        />
        <div className="mb-8 flex items-center gap-[5px]">
          <div className="text-[14px] font-[400] text-[#9c9c9e]">
            $23,040.33
            {/* <span className="text-[#6935D3]">(?)</span> */}
          </div>
        </div>
        <div className="h-[1px] mb-3 w-[459px] mx-auto bg-[#F2F2F7]"></div>
        <div className="flex justify-between mb-8 gap-[250px] items-center">
          <div className="flex items-center gap-[8px]">
            <img src={sale} alt="" className="w-[16px] h-[16px]" />
            <div className="text-[14px] font-[400] text-[#9C9C9E]">
              Current Valuation
            </div>
          </div>
          <div className="text-[14px] font-[400] text-[#9c9c9e]">
            $12,400/unit
          </div>
        </div>
        <FormControl component="fieldset">
          <RadioGroup
            aria-label="options"
            name="options"
            value={salesType}
            onChange={(e) => {
              setSalesType(e.target.value);
            }}
            row
          >
            <CustomFormControlLabel
              value="One-off sale"
              control={
                <Radio
                  sx={{
                    color: "#6935D3",
                    "&.Mui-checked": { color: "#6935D3" },
                  }}
                />
              }
              label="One-off sale"
            />
            <CustomFormControlLabel
              value="Fractional sale"
              control={
                <Radio
                  sx={{
                    color: "#6935D3",
                    "&.Mui-checked": { color: "#6935D3" },
                  }}
                />
              }
              label="Fractional sale"
            />
          </RadioGroup>
        </FormControl>
        <button
          onClick={() => {
            navigate("/investment-summary/2");
          }}
          className="w-[203px] mt-[20px] h-[45px] rounded-[8px] bg-[#6935D3] shadow-sm justify-center items-center flex font-[500] text-[16px] text-white"
        >
          Sell 10 units
        </button>
      </div>
    </div>
  );
};

export default RealEstateAmount;
